import { render, staticRenderFns } from "./OrganizeActivity.vue?vue&type=template&id=6beabf7c&scoped=true&"
import script from "./OrganizeActivity.vue?vue&type=script&lang=js&"
export * from "./OrganizeActivity.vue?vue&type=script&lang=js&"
import style0 from "./OrganizeActivity.vue?vue&type=style&index=0&id=6beabf7c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6beabf7c",
  null
  
)

export default component.exports